import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Button, ListItemIcon, ListItemText, MenuItem, styled } from '@material-ui/core';
import { CustomMenuItem } from 'src/config/api/models/CustomMenu';
import { FontAwesomeSpriteIcon } from '../FontAwesomeLocal';

export type CustomMenuListItemProps = {
  className: string;
  path?: string;
} & CustomMenuItem;

const StyledMenuItemButton = styled(Button)({
  width: '100%',
  borderRadius: 0,
  textTransform: 'none',
});

const CustomMenuListItem: FC<CustomMenuListItemProps> = ({
  onClick,
  path,
  target = '_self',
  label,
  className,
  icon,
}) => {
  return (
    <MenuItem
      component={path ? Link : StyledMenuItemButton}
      to={path}
      target={target}
      onClick={onClick}
      className={className}
    >
      {icon && (
        <ListItemIcon style={{ minWidth: 30 }}>
          <FontAwesomeSpriteIcon icon={icon} color={'grey'} iconSize="lg" />
        </ListItemIcon>
      )}
      <ListItemText
        style={{
          fontSize: 'small',
          overflow: 'hidden',
        }}
        primary={label}
      ></ListItemText>
    </MenuItem>
  );
};

export default CustomMenuListItem;
